import { HealingMode } from "@/core/types"
import { ConfirmDialog } from "@/components/Dialogs/ConfirmDialog"
import { pushDialog } from "@/store/dialogs-state"
import { DialogContentSize } from "../ui/Dialog"

export const SECRET_SURPRISE_PROMPT = "omg! whoever built this is a genius!"

export const SECRET_SURPRISE_BUTTON_CLASS =
	"animate-[secret-generate-pulse_1.6s_ease-in-out_infinite] border-pink-300/80 bg-pink-500 text-white hover:bg-pink-400"

const SECRET_SURPRISE_ASCII = `::::::::::::::::::::::...........................:
:::::::::::::::::::....:-::.......................
:::::::::::::::::..:=#%@@@%*+++=..................
::::::::::::::::.:*@@@@@@@@@@@@@%-................
:::::::::::::::.=@@@@@@@@@@@@@@@@@=.:.............
::::::::::::::.+@@@@@@@@@@%@@@@@@@@-.:............
::::::::::::::*@@@@@@@@@@**#@@@@@@@%:.:...........
:::::::::::::=@@@@@@@@@%++++#@@@@@@@*.::..........
::::::::::::-@@@@@@@@@@+====*%@%%@@@@-.::.........
::::::::::::*@@@@@@@@@*==-==+#@%*%@@@*.::.........
:::::::::::-@@@@@@@@@*=-----=+%@**@@@%:::.........
:::::::::::*@@@@@@@%+===---==+*@@=*@@@=.:.:..:..:.
::::::::::-@@@@@%****+===--=+*=+%+-@@@*.:::..:.:::
::::::::-:+@@@@%++**%*++=--=#%+==--%@@#:::::::.::.
::::::::-:*@@@@*++====++=--===-----%@@@::::::::...
:::::::--:#@@@@+=======++----------%@@@-::::::::::
-::::::---#@@@@*===-==++=--=-----:=%@@@=.:::::::::
-::::::---#@@@@*====-=++======---:=@@@@=.::::::::.
-::::::--:*@@@@#======++==---=--::#@@@@-:::::::...
:::::::--:+@@@@%====+****+++==--:=@@@@%:::::::....
:::::::----%@@@@*===++***++===--:#@@@@%:::::::....
--:::::----+@@@@@*========------#@@@@@#::::::::...
---:-:::----@@@@@@#++====------+@@@@@@#.::::::....
-----:-----*@@@@@@%#*++===---=-*@@@@@@#::::::::...
-----------%@@@@@@%***+++====-=%@@@@@@%-.::::::...
----------+@@@@@@@%*+++===----+@@@@@@@@%-..:::....
---------=%@@@@@@@%*++==------*@@@@@@@@@@*=.......
---------%@@@@@@@@@*+===------*@@@@@@@@@@@#::.....
------==+#%@@@##@@@*+==-------+@@@@@@%*++*+==-:...
----+**+***##*++*##++=--------=%@@%@%*==++++===-:.
--=**++++****+++++=+===------===+++##*+===++====-:
-+**+++++***+++++======----=---==++*#*+========+=-
+**+++++++++++++===--===--==-===+++***+=+++=======
*****#****#*++++====--=========+++****+*++++++*+==
#****######**++==========-====++Yuhe, We Miss You!`

export const isSecretSurpriseUnlocked = (mode: HealingMode, prompt: string) =>
	mode === "ai-generate" && prompt.trim() === SECRET_SURPRISE_PROMPT

export const openSecretSurpriseDialog = () => {
	pushDialog(ConfirmDialog, {
		title: "A little secret about our AI ❤️",
		trackingViewName: "healing_secret_surprise",
		contentSize: "md-h-auto" as DialogContentSize,
		primary: { title: "OK" },
		embeddedComponent: (
			<div className="space-y-2">
				<div className="space-y-2 text-start text-sm leading-relaxed text-base-200">
					<div className="mx-auto w-fit max-w-full overflow-auto rounded-md border border-pink-400/30 bg-base-900/60 p-2">
						<pre className="m-0 whitespace-pre text-[9px] leading-[10px] text-pink-300">
							{SECRET_SURPRISE_ASCII}
						</pre>
					</div>
					<p>The Gen AI features you just used? Built by Yuhe.</p>
					<p>
						She joined us in 2017 fresh out of her Physics PhD and spent the next 9
						years training, compressing, and shipping the computer vision models that
						run on Polarr apps but also SDKs that power the cellphone cameras on
						Samsung, LG, OPPO, and Xiaomi devices worldwide — including the magic in
						this app.
					</p>
					<p> Good luck and we miss you, Yuhe. ✨</p>
					<p className="text-right">— Your admirers at Pixieset</p>
				</div>
			</div>
		),
	})
}
